
































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { lccaStore } from '@/store/store';
import {
  evaluateAlternative,
  getAvailableProbVariables,
  mainLccaCalculation,
} from '@/modules/lcca/lib/calculations/lccaMethods';
import { ILccaAlternativeImperial } from '@/modules/lcca/interfaces/lccaCalculated';
import { BaseProbVariables, IAlternativeResult } from '@/modules/lcca/interfaces/probabilistic';
import { completeLcca } from '@/modules/lcca/lib/calculations/completeLcca';
import { createMonteCarloChart } from '@/modules/lcca/lib/calculations/probabilityFunctions';
import { createDeterministicChart } from '@/modules/lcca/lib/calculations/deterministicChart';
import { getProbabilisticByName, getUserProbInputs } from '@/modules/lcca/lib/util';
import { createLccaValidations } from '@/modules/lcca/lib/validations';
import { cashFlowDiagram } from '@/modules/lcca/lib/cashFlowDiagram';
// @ts-ignore
import { pickColors } from '@/modules/lcca/lib/pickColors';


@Component({
  components: {
    PxNumberInput,
    // InputPageWrapper,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class LccaReport extends Vue {
  @Prop() readonly pxLccaId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return lccaStore.currentScenario;
  }

  get scenarioImperial() {
    this.sync();
    return lccaStore.currentImperial;
  }

  validations() {
    return createLccaValidations(this.scenarioImperial);
  }

  sync() {
    lccaStore.setCurrentScenario(this.scenario);
  }

  get userProbInputs() {
    // Specifically for validation
    return getUserProbInputs(this.scenarioImperial);
  }

  get trafficProbabilisticInputs() {
    return getProbabilisticByName(this.scenario.probabilistic, BaseProbVariables.annualGrowthTraffic);
  }

  progress: number | null = null;

  get probVariables() {
    return getAvailableProbVariables(this.scenario);
  }

  // get isProbabilistic() {
  //   return this.probVariables.length > 0
  // }
  isProbabilistic: boolean | null = null;

  performCalculation() {
    // Get probabilistic parameters
    // const probVariables = getAvailableProbVariables(this.scenario);
    const { probVariables } = this;
    const options = mainLccaCalculation(this.scenarioImperial, probVariables);
    const scenarioOptions = options.scenario;
    const activityOptions = options.activity;

    const stds: number[] = [];

    const lowestAlternative = {
      user: {
        cost: Infinity,
        alternativeName: '',
      },
      agency: '',
    };

    // interface IActivityReturnResults {
    //   alternative: ILccaAlternative,
    //   agencyCosts: number,
    //   userCosts: number,
    //   delayCosts: number,
    //   vehicleCosts: number,
    //   resultBreakdown: IActivityResultBreakdown | null,
    //   queueLengthWarning: boolean
    // };

    const rr: IAlternativeResult[] = [];

    const monteCarloResults: any[] = [];
    const returnObj = {
      monteCarloResults,
      lowestAlternative,
      results: rr,
    };

    // Iterate
    let iteration = 0;
    const maxIterations = probVariables.length > 0 ? 2000 : 1;

    const alternativeMonteCarloDraws: { [key: number]: IAlternativeResult[] } = {};

    // Evaluate base scenario LCCA

    while (iteration < maxIterations) {
      iteration++;

      // Evaluate alternatives
      const scenarioLccaResults = completeLcca(this.scenarioImperial, scenarioOptions);

      this.scenarioImperial.alternatives.forEach((alternative: ILccaAlternativeImperial, i: number) => {
        const altResult = evaluateAlternative(alternative, activityOptions, probVariables, this.scenarioImperial);
        // console.log("Iteration", iteration, i, alternative.name, altResult.userCosts);

        if (Object.keys(alternativeMonteCarloDraws).includes(i.toString())) {
          alternativeMonteCarloDraws[i].push(altResult);
        } else {
          alternativeMonteCarloDraws[i] = [altResult];
        }
      });
    }

    // console.log("montecarloresults", alternativeMonteCarloDraws);


    if (probVariables.length > 0) {
      this.$nextTick(
        function () {
          createMonteCarloChart(this.scenarioImperial, null, alternativeMonteCarloDraws, maxIterations);
        },
      );
    } else {
      this.$nextTick(
        function () {
          createDeterministicChart(this.scenarioImperial, alternativeMonteCarloDraws);


          Object.values(alternativeMonteCarloDraws).forEach((altResultList, m) => {
            const altResult = altResultList[0];
            const colors = pickColors(altResult.alternative.activities.length);

            // @ts-ignore
            const alternativeData = [];
            // This is how it was done in the old code
            altResult.alternative.activities.forEach((activity, i) => {
              const resultObj = {
                startYear: activity.startYear,
                agencyConstructionCost: activity.agencyConstructionCost_thousands,
                serviceLife: activity.serviceLife_yrs,
                structuralLife: activity.structuralLife_yrs,
                color: colors[i],
                category: activity.name,
                userWorkzoneCost: activity.userWorkzoneCost_thousands,
              };
              alternativeData.push(resultObj);
            });

            // @ts-ignore
            cashFlowDiagram(alternativeData, m);
          });
        },
      );
    }


    // Identify lowest-cost alternative from results

    // Collect deterministic plot results
  }

  created() {
    this.isProbabilistic = this.probVariables.length > 0;
    // console.log(document.getElementById('monteCarloPlotContainer').offsetWidth)
    this.$nextTick(
      function () {
        this.performCalculation();
      },
    );
  }
}

